import React from 'react'
import { FormattedMessage } from 'react-intl'

import { cn } from '../../../shadcn/utils'

const colors = {
  ['available']: 'bg-green-100 text-green-500',
  ['unavailable']: 'bg-red-100 text-red-500',
  ['waiting-confirmation']: 'bg-grey-300 text-grey-700',
} as const

export const DisponibilityTag = ({ tag }: { tag: keyof typeof colors }) => {
  const getLabel = (): React.ReactNode => {
    switch (tag) {
      case 'available':
        return (
          <FormattedMessage
            id='ui.DisponibilityTag.available'
            defaultMessage='Disponible'
          />
        )
      case 'unavailable':
        return (
          <FormattedMessage
            id='ui.DisponibilityTag.unavailable'
            defaultMessage='Indisponible'
          />
        )
      case 'waiting-confirmation':
        return (
          <FormattedMessage
            id='ui.DisponibilityTag.waiting-confirmation'
            defaultMessage='Disponibilité à confirmer'
          />
        )
    }
  }

  return (
    <span className={cn('rounded-full px-2 py-1 text-xs', colors[tag])}>
      {getLabel()}
    </span>
  )
}
